import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "admin-federation-list"
}
const _hoisted_2 = { class: "d-flex pt-4 pb-4 align-items-center" }
const _hoisted_3 = { class: "fs-5" }
const _hoisted_4 = { class: "d-flex align-items-center ms-auto" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = { class: "flex-shrink-0" }
const _hoisted_7 = { class: "avatar avatar-circle" }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 1,
  class: "avatar-img",
  src: "https://htmlstream.com/preview/front-v4.3.1/assets/img/160x160/img1.jpg"
}
const _hoisted_10 = { class: "flex-grow-1 ms-3 mb-0" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "justify-content-end d-flex" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil-square" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash" }, null, -1)
const _hoisted_15 = { class: "pt-4 pb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CreateFederationModal = _resolveComponent("CreateFederationModal")!
  const _component_DeleteEntityModal = _resolveComponent("DeleteEntityModal")!
  const _component_MrUiKitButton = _resolveComponent("MrUiKitButton")!
  const _component_MrUiKitTable = _resolveComponent("MrUiKitTable")!
  const _component_MrUiKitPagination = _resolveComponent("MrUiKitPagination")!
  const _component_MrUiKitCard = _resolveComponent("MrUiKitCard")!

  return (_ctx.isMounted)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.showModal)
          ? (_openBlock(), _createBlock(_component_CreateFederationModal, {
              key: 0,
              onSubmit: _ctx.onSubmitForm,
              onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModal = false))
            }, null, 8, ["onSubmit"]))
          : _createCommentVNode("", true),
        (_ctx.showDeleteModal === true && _ctx.selectedFederation)
          ? (_openBlock(), _createBlock(_component_DeleteEntityModal, {
              key: 1,
              name: _ctx.selectedFederation.fullname,
              onSubmit: _ctx.onSubmitDelete,
              onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDeleteModal = false))
            }, null, 8, ["name", "onSubmit"]))
          : _createCommentVNode("", true),
        _createVNode(_component_MrUiKitCard, {
          headerClasses: ['border-bottom'],
          bodyClasses: ['pt-0']
        }, {
          header: _withCtx(() => [
            _createElementVNode("h4", null, _toDisplayString(_ctx.t("common.tabs.federations")), 1)
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.t("backoffice.sideNavTabs.subtitles.manageFederation")), 1)
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_MrUiKitButton, { onClick: _ctx.onOpenModal }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("common.operations.add")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            _createVNode(_component_MrUiKitTable, {
              rows: _ctx.federations,
              columns: _ctx.columns,
              search: true,
              searchLabel: _ctx.searchLabel,
              onSearch: _ctx.onSearch
            }, {
              name: _withCtx(({ item }) => [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      (item.logo)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "avatar-img",
                            src: item.logo.url
                          }, null, 8, _hoisted_8))
                        : (_openBlock(), _createElementBlock("img", _hoisted_9))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("h5", {
                      class: "mb-0 link-navigate",
                      onClick: () => _ctx.onNavigate(item)
                    }, _toDisplayString(item.fullname), 9, _hoisted_11)
                  ])
                ])
              ]),
              action: _withCtx(({ item }) => [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_MrUiKitButton, {
                    classes: ['btn-icon btn-primary-outline btn-sm'],
                    onClick: ($event: any) => (_ctx.onNavigate(item))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_13
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_MrUiKitButton, {
                    classes: ['btn-icon btn-primary-outline btn-sm'],
                    onClick: ($event: any) => (_ctx.onDelete(item))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_14
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ])
              ]),
              _: 1
            }, 8, ["rows", "columns", "searchLabel", "onSearch"]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_MrUiKitPagination, {
                modelValue: _ctx.pagination,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pagination) = $event)),
                onLoad: _ctx.loadMore
              }, {
                default: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(_ctx.t("pagination.page")) + " " + _toDisplayString(_ctx.pagination.current) + " " + _toDisplayString(_ctx.t("pagination.of")) + " " + _toDisplayString(slotProps.lastPage), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "onLoad"])
            ])
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}